import moment from 'moment';
import { FC, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { formatUSDNoDecimals } from '../../../../../helpers/helpers';
import { HubsTradingPackage, PackageOrder } from '../../types';
import { PackageConverted } from './PackageDisabled';
import { color } from '../../../../../styles/GlobalStyles';

export const TravelHub: FC<any> = ({ data }: { data: PackageOrder }) => {
  const returnFractions = (name: string) => {
    switch (name) {
      case 'Starter':
        return 2;
      case 'Basic':
        return 4;
      case 'Builder':
        return 8;
      case 'Pro':
        return 20;

      case 'Promo Starter':
        return 2;

      case 'Promo Basic':
        return 4;
      case 'Promo Builder':
        return 8;
      case 'Promo Pro':
        return 20;

      default:
        break;
    }
  };

  return (
    <div
      className='d-flex mb-3 mt-2 border border-primary'
      style={{ position: 'relative' }}>
      <img width={200} style={{ marginRight: 20 }} src={data.imageUrl} />
      <div className='flex-column'>
        <div className='w-100 mb-4'>
          <div className='d-flex'>
            <Col lg={5} className='border-end p-3'>
              <h5 className='text-muted text-uppercase fs-13'>ORDER ID</h5>
              <h4 className='fs-15 mb-0'>{data.id}</h4>
            </Col>
            <Col lg={5} className='border-end p-3'>
              <h5 className='text-muted text-uppercase fs-13'>PACKAGE PRICE</h5>
              <h4 className='fs-15 mb-0'>
                {formatUSDNoDecimals(data.price)} USDT/USDC
              </h4>
            </Col>
            <Col lg={5} className='border-end p-3'>
              <h5 className='text-muted text-uppercase fs-13'>
                DATE OF PURCHASE
              </h5>
              <h4 className='fs-15 mb-0'>
                {moment(data?.datePaid).format('DD MMM YYYY')}
              </h4>
            </Col>
          </div>
        </div>
        <div className='w-100'>
          {data?.name === 'Starter' ? (
            <h5></h5>
          ) : (
            <h5 color={color.colors.secondary100}>
              Unica Pay Card Tier: {data?.unicaPay?.name}
            </h5>
          )}

          {data?.minara?.credits && (
            <h5>Minara Credits: {data?.minara?.credits}</h5>
          )}

          <h5 color={color.colors.secondary100}>
            Academy Access: {data?.u1Academy?.name}
          </h5>
          {data?.name === 'Ultimate' ||
          data?.name === 'Promo Ultimate' ||
          data?.name === 'Elite' ||
          data?.name === 'Promo Elite' ? (
            <h5>Futura Mining Hardware: UNLIMITED</h5>
          ) : (
            <div className='flex-column'>
              <h5>
                Futura Mining Hardware: Max Fractions -{' '}
                {returnFractions(data?.name)}
              </h5>
              <h5>
                (Up To {formatUSDNoDecimals(data?.futuraMining?.limit)}{' '}
                USDT/USDC)
              </h5>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
